exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nh1 {\n    color: #369;\n    font-family: Arial, Helvetica, sans-serif; font-size: 250%;\n}\n\nbody {\n    margin: 2em;\n    background-color: lightgrey;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/opt/build/repo/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/opt/build/repo/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles